export default username => {
    // Only letters (a-z, A-Z) and numbers (0-9) allowed
    return /^[a-zA-Z0-9]+$/.test(username);
};
